import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'sg-ng-button-social',
    templateUrl: './button-social.component.html',
    styleUrls: ['./button-social.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class ButtonSocialSharedComponent {
    @Input() label: string;
    @Input() social: string;
    @Input() path: string;
}
